import { Download } from "lucide-react";
import { formatVersion } from "../../../utils/formatters";
import {
  downloadGovernanceDocumentVersionFile,
  type VersionInfo,
} from "../../../api/frameworksApi";
import { formatDate, formatFileSize, triggerDownload } from "./utils";

/* ── Version Row Component ── */
export function VersionRow({
  version,
  docId,
}: {
  version: VersionInfo;
  docId: string;
}) {
  return (
    <div className="flex items-center justify-between px-4 py-3">
      <div className="flex items-center gap-3">
        <span className="font-mono font-bold text-sm text-foreground">
          {formatVersion(version.versionNumber)}
        </span>
        <span className="text-xs text-muted-foreground">{formatDate(version.createdAt)}</span>
        {version.hasFile && (
          <span className="text-xs text-muted-foreground">
            {version.fileName} ({formatFileSize(version.fileSize)})
          </span>
        )}
      </div>
      {version.hasFile && (
        <button
          onClick={() =>
            triggerDownload(
              downloadGovernanceDocumentVersionFile(
                docId,
                version.versionNumber,
              ),
              version.fileName,
            )
          }
          className="p-1.5 rounded-md border border-border hover:bg-accent transition-colors text-foreground"
          title="Download"
        >
          <Download className="size-3.5" />
        </button>
      )}
    </div>
  );
}
